import { axios } from './axiosClient';
import { useAuthStore } from '@/stores/auth';
import { getSessionsDetailsSchema } from '@/types/schemas/auth/getSessionDetails';
import { validate } from '@/utils/errors/helpers';
import { getMWParamsSchema } from '@/types/schemas/auth/getMWParams';
import { stringMessageSchema } from '@/types/schemas/stringMessage';
import { getInstallationSchema } from '@/types/schemas/mw/getInstallation';

export async function pingServer() {
  try {
    const response = await axios.get(`v2/admin/health-check`);
    validate(stringMessageSchema, response.data);
    return response.status === 200;
  } catch (error) {
    console.log('Network error', error);

    return false;
  }
}

export async function userLogin() {
  const { username, password, dbName } = useAuthStore();
  const response = await axios.post(`v2/users/login?dbName=${dbName}`, {
    username: username,
    password: password,
    dbName: dbName,
    isMobile: false,
  });

  const validatedData = validate(stringMessageSchema, response.data);
  if (response.status === 200) return validatedData;
  return null;
}

export async function getSessionDetails() {
  const response = await axios.get(`v2/admin/session`);
  return validate(getSessionsDetailsSchema, response.data);
}

export async function resetPassword(email: string, username: string, dbName: string) {
  const response = await axios.post(`/v2/users/reset-password?dbName=${dbName}`, {
    email,
    username,
  });
  return validate(stringMessageSchema, response.data);
}

export async function getCompanyMWParams() {
  const response = await axios.get(`v2/mw/params`);
  return validate(getMWParamsSchema, response.data.data);
}

export async function getUserMenus() {
  const response = await axios.get(`v2/users/user-menus`);
  return validate(getInstallationSchema, response.data);
}

export async function getTraderSites(
  searchTerm: string,
  skip: number = 0,
  take: number = 5,
  sortColumn: string,
  sortOrder: string = 'asc'
) {
  const response = await axios.post('/v2/tradersite/gettradersites', {
    'searchText': searchTerm,
    'take': take,
    'skip': skip,
    'column': sortColumn,
    'order': sortOrder,
  });
  return response.data.result;
}
